import React from 'react';
import xtend from 'xtend';
import _ from 'underscore';
import EventsListSearch from './EventsListSearch';
import DateFilters from '../../../../events/components/DateFilters';
import { apiDateFormat } from '../../../../utils/Formatter';
var noop = function () {};


function EventsListQuery (props) {

    function handleSubmit (ev) {
        ev.preventDefault();
        var els = ev.target.elements;
        var searchValue = els['events-list-search'].value;
        var search = {};
        if (props.searchBy.key && searchValue) {
            search[props.searchBy.key] = searchValue;
        }
        // console.log('search', search);
        props.onSubmit(search);
    }

    function handleDateChange (ev) {
        var asStrings = _(ev).reduce(function (acc, date, k) {
            acc[k] = date.format(apiDateFormat);
            return acc;
        }, {});
        props.onChange(xtend(asStrings, {
            includePrivate: true
        }));
    }

    var dateFilters = {
        startDateTime: props.startDateTime,
        stopDateTime: props.stopDateTime
    };

    var searchByID = props.searchBy.key === 'eventID' ||
        props.searchBy.key === 'customID'
    ;

    return <form className="events-list-query" style={{ padding: '1em' }}
        onSubmit={handleSubmit}
    >
        <EventsListSearch
            disabled={props.disabled}
            activeParameter={props.searchBy.key}
            onParamSelect={props.onSearchParamChange}
            showCategories={false}
            showKeywords={false}
            name="events-list-search"
        />

        <div className="row">
            <div className="col-sm-8">
                <DateFilters
                    filters={dateFilters}
                    onChange={handleDateChange}
                    disabled={searchByID || props.disabled}
                />
            </div>
            <div className="col-sm-4 pull-right text-right">
                <button className="btn btn-default" type="submit"
                    disabled={props.disabled}
                >
                    Submit
                </button>
            </div>
        </div>

    </form>;
}

// EventsListQuery.propTypes = {
//     startDateTime: pt.string.isRequired,
//     stopDateTime: pt.string.isRequired,
//     sortBy: pt.oneOf(['ASC', 'DESC']).isRequired,
//     searchBy: pt.shape({
//         key: pt.string,
//         value: pt.string
//     }),
//     onChange: pt.func.isRequired,
//     onSearchParamChange: pt.func,
//     onSubmit: pt.func.isRequired,
//     disabled: pt.bool
// };

// @TODO
// maybe we can change `react-pull-stream` so that it doesn't render
// before the initial state comes through the stream
EventsListQuery.defaultProps = {
    onSearchParamChange: noop,
    onSubmit: noop,
    startDateTime: '',
    stopDateTime: '',
    sortBy: 'DESC',
    searchBy: {
        key: null,
        value: null
    }
};

export default EventsListQuery;
